import { destroySocketConnection, initSocketConnection } from '@interhyp/platform-notification';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isAuthenticated } from '../redux/StateSession/selectors';

export function useFrontendNotifications() {
  const isAuthed = useSelector(isAuthenticated);

  useEffect(() => {
    if (isAuthed) {
      initSocketConnection();
      return () => {
        destroySocketConnection();
      };
    }
  }, [isAuthed]);
}
